import { HTMLAttributes, ReactNode } from 'react';
import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';
import { Tag } from './components/Tag';
import { Content } from './components/Content';
import { Footer } from './components/Footer';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const Card = ({ children, className, ...props }: CardProps) => {
  return (
    // need custom grid here because i need the firsts row and the last row to be set to auto
    <div
      className={flattenClassNames([
        'grid grid-rows-[auto_minmax(0,_1fr)_auto] rounded-lg bg-bg-secondary p-4 shadow-primary-outset',
        className,
      ])}
      {...props}
    >
      {children}
    </div>
  );
};

Card.Tag = Tag;
Card.Content = Content;
Card.Footer = Footer;
